import React from 'react';
import { FadeIn } from './FadeIn';
import { Zap } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="py-24 bg-charcoal text-white" data-id="element-100">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-101">
        <FadeIn data-id="element-102">
          <div className="text-center mb-12" data-id="element-103">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-terracotta/20 text-terracotta mb-6" data-id="element-104">
              <Zap size={32} strokeWidth={1.5} data-id="element-105" />
            </div>
            <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-106">
              El Sistema de "Bloques de Fatiga"
            </h2>
          </div>

          <div className="prose prose-lg prose-invert mx-auto text-center" data-id="element-107">
            <p className="text-xl text-linen/90 leading-relaxed mb-8" data-id="element-108">
              Este método no asume que tienes energía;{' '}
              <span className="text-terracotta font-semibold" data-id="element-109">
                asume que estás agotada.
              </span>
            </p>
            <p className="text-warmgray font-light leading-relaxed" data-id="element-110">
              En lugar de tareas largas, sincronizamos micro-acciones de 120
              segundos con los tiempos muertos de la cocina. Mientras el agua
              hierve, la casa se ordena. Es un sistema de ejecución automática
              donde tu cerebro descansa mientras tus manos recuperan la paz de
              tu hogar en fracciones de 15 minutos.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}